import React from "react";
import {ElementTypeDto} from "../../../../common/apis/Elements";
import {ArchimateElement} from "../../../../common/archimate/ArchimateElement";
import {ArchimateLayer, ArchimateLayerType} from "../../../../common/archimate/ArchiMateLayer";
import ElementTypeIcon from "../../../../components/fields/ElementTypeIcon";
import SingleSelectField from "../../../../components/fields/select/SingleSelectField";
import {t} from "../../../../store/localization/TranslMessasge";

interface ElementTypeSingleSelectFieldProps {
    label: string,
    options: ElementTypeDto[],
    value: ElementTypeDto | null,
    onChange: (value: ElementTypeDto | null) => void
    errorMessage?: string,
}

export default function ElementTypeSingleSelectField(props: Readonly<ElementTypeSingleSelectFieldProps>) {
    const { options, value, label, onChange, errorMessage } = props;

    function getLayerName(elementStandardName: string) {
        const layerType = ArchimateElement.findByStandardName(elementStandardName)?.layerType || ArchimateLayerType.VIRTUAL_LAYER_CONNECTORS;
        return t(ArchimateLayer[layerType].translationKey);
    }

    function renderOptionComponent(option: ElementTypeDto, label: string) {
        return (
                <span>
                    <ElementTypeIcon name={option.name}/>
                    <span>{label}</span>
                </span>
        );
    }

    const sortedOptions: ElementTypeDto[] = [...options].sort((a, b) => {
        const aLayerName = getLayerName(a.name);
        const bLayerName = getLayerName(b.name);
        if (aLayerName === bLayerName) {
            return a.code.localeCompare(b.code)
        } else {
            return aLayerName.localeCompare(bLayerName);
        }
    });

    return (
            <SingleSelectField
                    label={label}
                    value={value}
                    onChange={onChange}
                    options={sortedOptions}
                    getOptionLabel={(option) => ArchimateElement.findByStandardName(option.name)?.visibleName || ""}
                    required={true}
                    errorMessage={errorMessage}
                    renderOptionComponent={renderOptionComponent}
                    groupBy={(option) => getLayerName(option.name)}
            />
    );
}
